var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"codeblock pl-4 pt-4 pb-2 mb-2"},[_c('p',{staticClass:"code"},[_vm._v(" "+_vm._s(this.content)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }